module Meevo.Components.Controls {

    import IMeevoMessengerApiService = Meevo.Plugins.MeevoMessenger.IMeevoMessengerApiService;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import MessengersEnum = Meevo.Plugins.MeevoMessenger.MessengersEnum;
    import AppointmentStatuses = Meevo.Plugins.MeevoMessenger.AppointmentStatuses;
    import MeevoMessengerConversation = Meevo.Plugins.MeevoMessenger.MeevoMessengerConversation;

    class MeevoMessagePreviewComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.plugins.meevoMessenger.meevoMessengerApiService',
            'meevo.components.busy.BusyService'
        ];

        public initials = '*U';
        public chatPreview: MeevoMessengerConversation | null;
        public isAttentionToggled = false;
        public showPlaceholderImage;
        public isShowAlerts: boolean;
        public classification: MessengersEnum;
        public displayName: string;
        public timeZoneOffset: string;

        constructor(private $scope: ng.IScope,
                    protected meevoMessengerApiService: IMeevoMessengerApiService,
                    protected busyService: Meevo.Components.Busy.IBusyService) {  }

        $onInit() {
            if (!this.chatPreview) {
                this.chatPreview = null;
            }

            if (_.isUndefined(this.showPlaceholderImage)) {
                this.showPlaceholderImage = true;
            }

            if (this.chatPreview.displayName) {
                this.getDisplayNameAndInitials();
            }

            if (!!this.chatPreview.followUp) {
                this.isAttentionToggled = true;
            }

            this.$scope.$watch(() => this.chatPreview.displayName, (oldValue, newValue) => {
                if (newValue !== oldValue) {
                    this.getDisplayNameAndInitials();
                }
            })
        }

        getDisplayNameAndInitials() {
            this.displayName = `${this.chatPreview.displayName}`;
            this.initials = this.getInitials(this.displayName);
        }

        getContactName(): string {
            const displayName = this.chatPreview.displayName;

            if (displayName) {
                return `${displayName}`;
            }

            return '*Unknown';
        }

        getInitials(fullName: string): string {
            return fullName.split(" ").map((name, i, arr) => i === 0 || i + 1 === arr.length ? name[0] : null).join("").toUpperCase();
        }

        toggleAttention() {
            this.chatPreview.objectState = ObjectStateEnum.Active;
            this.chatPreview.followUp = !this.chatPreview.followUp;
            this.busyService.start();
            this.meevoMessengerApiService.updateConversation(this.chatPreview).then(data => {
                if (data) {
                    this.chatPreview.entityVersion = data.entityVersion;
                }
            }).finally(() => {
                this.busyService.stop();
            });
        }

        getLastMessageStatusStyle(): string {
            if (this.chatPreview && this.chatPreview.lastMessage) {
                if (!this.chatPreview.lastMessage.isInbound) {
                    return 'sent-status';
                }

                if (this.chatPreview.lastMessage.isInbound && this.chatPreview.lastMessage.isRead) {
                    return 'viewed-status';
                }

                if (this.chatPreview.lastMessage.isInbound && !this.chatPreview.lastMessage.isRead) {
                    return 'unread-status';
                }
            }

            return ''
        }

        getAvatar(): string | null {
            if (this.isAvatar()) {
                return this.chatPreview.meevoFile.files[0].fileUrl;
            }
            return null;
        }

        isAvatar(): boolean {
            return this.chatPreview.meevoFile &&
                this.chatPreview.meevoFile.files &&
                this.chatPreview.meevoFile.files[0] &&
                this.chatPreview.meevoFile.files[0].fileUrl;
        }

        get convertedTime() {
            let timeOffset = this.timeZoneOffset.substring(0, this.timeZoneOffset.indexOf(':'));
            if (this.chatPreview && this.chatPreview.lastMessage && this.chatPreview.lastMessage.createdDateTime) {
                return moment(this.chatPreview.lastMessage.createdDateTime).add(timeOffset, 'hours').format('MM/DD/YY @ h:mma');
            }
            return ''

        }

        get isShowPhoneNumber(): boolean {
            return this.chatPreview.classification.toUpperCase() != 'MEGO';
        }

        get messengerClassification() {
            return MessengersEnum;
        }

        get appointStatus() {
            return AppointmentStatuses;
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoMessagePreviewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/message-preview/message-preview.component.html',
            controller: MeevoMessagePreviewComponent,
            controllerAs: '$ctrl',
            bindings: {
                chatPreview: '<',
                showPlaceholderImage: '<?',
                isDisabled: '<?',
                isShowAlerts: '<?',
                timeZoneOffset: '<?',
                classification: '=?'
            }
        });
}
